export default __webpack_public_path__ + "static/media/DUBLIN BUSINESS SCHOOL.2bff12c1.png";